var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sm-settings-main"},[_c(_vm.currentTab,{tag:"components"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }